import { useEffect, useState } from "react";
import useAxiosInstance from "../../../Utilities/Hooks/useAxiosInstance";
import Form from "../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import FormSubmitButton from "../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";



function UpdateState({
    targetID,
    employee,
    setShowUpdateForm,
    setShowModal,
    triggerFetch,
}) {
    const [name, setName] = useState("");
    const axiosInstance = useAxiosInstance();

    useEffect(() => {
        async function fetchAndSetAds() {
            const { data } = await axiosInstance.get("states/getSingleState/" + targetID);
            setName(data.name);

        }
        fetchAndSetAds();
    }, [targetID, axiosInstance]);

    async function handleSubmit(e) {
        e.preventDefault();

        const itemData = new FormData();
        itemData.append("name", name);

        const response = await axiosInstance.patch("states/" + targetID, itemData);

        if (response.data) {
            setShowUpdateForm(false);
            setShowModal(false);
            triggerFetch();
        }
    }

    return (
        <Form onSubmit={handleSubmit} hasImage>
            <ShortTextInput
                label={`State Name`}
                value={name}
                placeholder={`Enter State Name`}
                setState={setName}
            />

            <FormSubmitButton text="Update State" />
        </Form>
    );
}

export default UpdateState;
